import { getStatusKeyByLabel } from "../Invitation/Model/InvitationStatus"
import { ObservableFromFetch } from "../ObservableFromFetch"
import { InvitationGridRequest } from "./Model/InvitationGridRequest"
import { InvitationGridResponse } from "./Model/InvitationGridResponse"

function gridParams(options: InvitationGridRequest): string {
  return JSON.stringify({
    Filters: {
      CompanyName: options.filters.find(filter => filter.column === "CompanyName")?.values || [],
      EmailAddress: options.filters.find(filter => filter.column === "EmailAddress")?.values || [],
      EnrollmentStarted: options.filters.find(filter => filter.column === "EnrollmentStarted")?.values || [],
      InActive: options.filters.find(filter => filter.column === "InActive")?.values.map(value => value === "Inactive") || [],
      InvitationSent: options.filters.find(filter => filter.column === "InvitationSent")?.values || [],
      Role: options.filters.find(filter => filter.column === "Role")?.values || [],
      Status: options.filters.find(filter => filter.column === "Status")?.values.map(getStatusKeyByLabel) || [],
    },
    IsQuickStart: false,
    PageNumber: options.pageNumber,
    PageSize: options.pageSize || 20,
    SortGrid: { SortColumn: options.sort?.column || "", SortOrder: options.sort?.order.toUpperCase() === "DESC" ? "DSC" : options.sort?.order.toUpperCase() },
    TimeZoneOffset: new Date().getTimezoneOffset()
  })
}

export default function InvitationStatusGrid(params: InvitationGridRequest) {
  return ObservableFromFetch<InvitationGridResponse>("FFOrderClinicEnrollment/GetClinics", gridParams(params))
}
